import React from 'react';
import './products.css'
import cookie from 'react-cookies';

import Topbar2 from "../../component/topbar2"
import { requestGet,getAllUrlparameter,requestLog} from '../../component/functions';
import { Row, Col ,Input,Pagination,List,Skeleton,Empty,Modal,Select} from 'antd';

const { Search } = Input;
const { Option } = Select;

class Policy extends React.Component {
    constructor(props) {
        //父组件传入参数
        super(props);
        //当前组件状态
        this.state = {
            mobile:false,

            jwt:"none",
            // 搜索框内容
            selectItem:"normal",
            searchkey:"",
            loading:false,
            requestdone:false,
            notLoggedModal:false,
            appletModal:false,

            year:2022,
            pagination:{            
                //当前页数
                cutpage:1,          
                //总页数   
                totalpage:1,        
            },

            // 搜索结果
            result:[],
            govurl:'',
        }
    };


    componentDidMount() {
        // console.clear();
        if (cookie.load("jwt_v2") !== undefined) {
            this.setState({
              jwt: cookie.load("jwt_v2"),
            });
        }
        this.deviceCheck()

        // // 测试用
        // this.state.searchkey="上海"
        // this.requestresult(1)
    }


    deviceCheck = () =>{
        if(getAllUrlparameter()["applet"] === "1"){
            this.setState({
                mobile: true,
                jwt: getAllUrlparameter()['jwt']
            });
        }
    }


    // 修改年份
    changeyear =(e)=>{
        this.setState({
            year: e
        });
        this.requestresult(1)
    }

    // 输入框内容改变
    changeinput = (e)=>{
        this.setState({
            searchkey:e.target.value
        })
    }

    // 搜索框
    search = (e) =>{
        if(e !== ""){
            if(this.state.jwt !== "none"){
              this.setState({
                searchkey: e,
              });
              this.requestresult(1)
            }else{
                this.setState({notLoggedModal:true})
                // alert("请登录后使用！")
            }
        }
    }

    // 改变页码
    changepage =(e)=>{
        this.requestresult(e)
    }

    changeSelect = (e) =>{
        this.setState({
            selectItem: e
        });
    }
    
    // 发起搜索
    requestresult = (page) =>{
        if(!this.state.mobile){
            requestLog('post:https://app.moxidata.cn/forest/policies/:query',cookie.load("jwt_v2")).then((data)=>{})
        }else{
            requestLog('post:https://app.moxidata.cn/forest/policies/:query_Mobile',cookie.load("jwt_v2")).then((data)=>{})
        }

        this.setState({loading:true})
        let url = `https://gateway1.moxidata.cn/mktcharts/policies/?method=query&intpage=${page}&querywords=${this.state.searchkey}&query_type=${this.state.selectItem}`;

        requestGet(url).then((value)=>{
            if(value.error){
                this.setState({
                    loading:false,
                    result:value.records,
                    pagination:{            
                        cutpage:value.cutpage,          
                        totalpage:value.totalpage,        
                    },
                    requestdone:true,

                })
            }else{
                this.setState({
                    loading:false,
                    requestdone:true,
                    result:[],
                    pagination:{            
                        cutpage:1,          
                        totalpage:1,        
                    },
                })
            }
            // console.log("result",value)
        })
    }


    render() {
        if(!this.state.mobile){
            let JSXResultContent = <></>
            if(this.state.loading){
                JSXResultContent=<div style={{backgroundColor:"white",padding:"20px"}}><Skeleton /><Skeleton /><Skeleton /><Skeleton /></div>
            }else{
                if(this.state.result.length>0){
                    JSXResultContent = <List
                        className='model-result-list'
                        size="large"
                        dataSource={this.state.result}
                        renderItem={(item) => <List.Item>
                            <Row style={{width:"100%"}} justify="space-between" wrap={false}>
                                <Col className='policy-result-title'><a href={item.sinfourl} target="_blank" rel="noreferrer">{item.sinfotitle}</a></Col>
                                <Col className='policy-result-info' style={{marginLeft:"20px"}}>{item.spublictime}{'\u00A0'}{'\u00A0'}{'\u00A0'}{item.swebsitename}</Col>
                            </Row>
                            
                        </List.Item>}
                    />
                }else{
                    JSXResultContent = <Row className='corpus-result-body' style={{height:"300px"}} align="middle" justify='center'>
                            <Empty description={<div style={{color:"black"}}>暂无数据，换个词试试吧！</div>}/>
                        </Row>
                }
            }

            const JSXNotLoggedModal = 
            <Modal title="未登录" cancelText="关闭" okText="登录/免费注册" visible={this.state.notLoggedModal} onOk={()=>{this.setState({notLoggedModal:false});window.location.href="/forest/login"}} onCancel={()=>{this.setState({notLoggedModal:false})}}>
                <p>本工具完全免费</p>
                <p>请在登录 / 免费注册后使用！</p>
            </Modal>
            
            return (
                <div style={{minWidth:"1200px"}}>
                    {JSXNotLoggedModal}

                    <Topbar2 pagetitle="文旅政确"/>
                    <Row className='policy-funbody'>
                        {/* 搜索框 */}
                        <Row className={!this.state.requestdone?"prodects-search-body prodects-search-body-init":"prodects-search-body prodects-search-body-searched"}>
                            <Input.Group compact className='prodects-search'>
                                <Select style={{width:"15%"}} size="large" defaultValue="normal" onChange={this.changeSelect}>
                                    <Option value="normal">政策</Option>
                                    <Option value="purchase">政府采购</Option>
                                </Select>
                                <Search style={{width:"85%"}} placeholder="请输入关键词" size="large" value={this.state.searchkey} onChange={this.changeinput}  onSearch={this.search} loading={this.state.loading} allowClear />
                            </Input.Group>
                        </Row>

                        {
                            !this.state.requestdone &&<Row className='products-introduce' justify='center'>
                                <Col span={12}>紧随官方文件指导，了解政策最新动态~</Col>
                            </Row>
                        }

                        {/* 搜索结果 */}
                        <div className={!this.state.requestdone?"prodects-result-body prodects-result-body-hide":"prodects-result-body"}>
                            <Row>
                                <div className='model-result-tabs' defaultActiveKey="1" onChange={this.changeyear}>
                                    {JSXResultContent}
                                </div>
                            </Row>
                            {
                                !this.state.loading && this.state.result.length >0 &&
                                <Row className='model-result-pagination' justify='center'>
                                    <Pagination defaultCurrent={1} current={this.state.pagination.cutpage} total={this.state.pagination.totalpage*10} showSizeChanger={false} onChange={this.changepage}/>
                                </Row>
                            }
                            
                        </div>
                    </Row>
                    

                </div>
            );
        }else{
            let JSXResultContent = <></>
            let JSXModal =<></>
            if(this.state.loading){
                JSXResultContent=<div style={{backgroundColor:"white",padding:"20px"}}><Skeleton /><Skeleton /><Skeleton /><Skeleton /></div>
            }else{
                if(this.state.result.length>0){
                    JSXModal = <Modal title="文件查看" visible={this.state.appletModal} onOk={()=>{this.setState({appletModal:false})}} okText="我知道了" cancelText="关闭" onCancel={()=>{this.setState({appletModal:false})}} closeIcon={<></>} >
                        <p>由于微信限制，无法在小程序内打开外部政府网站</p>
                        <p style={{color:"blue"}}>{this.state.govurl}</p>
                        <p>请复制网址后在浏览器打开</p>
                    </Modal>

                    JSXResultContent = <List
                        className='model-result-list'
                        size="large"
                        dataSource={this.state.result}
                        renderItem={(item) => <List.Item>
                            <Row style={{width:"100%"}} justify="space-between" wrap={false}>
                                <Col  className='policy-result-title'><span style={{color:"rgb(0,0,238)"}} onClick={()=>{this.setState({appletModal:true,govurl:item.sinfourl})}} target="_blank">{item.sinfotitle}</span></Col>
                                <Col  className='policy-result-info' style={{marginLeft:"20px",textAlign:"right",color:"#666666"}}>
                                    <div>{item.swebsitename}</div>
                                    <div>{item.spublictime}</div>
                                </Col>
                            </Row>
                        </List.Item>}
                    />
                }else{
                    JSXResultContent = <Row className='corpus-result-body' style={{height:"300px"}} align="middle" justify='center'>
                            <Empty description={<div style={{color:"black"}}>暂无数据，换个词试试吧！</div>}/>
                        </Row>
                }
            }
            return (
                <div className="mobile-artkey-funbody">
                    {JSXModal}
                    <Row justify='center'><Col className='mobile-products-pagetitle'>文旅政确</Col></Row>
                    <Row style={{marginTop:this.state.requestdone?"20px":"30vh",transition:".5s"}}><Search className='mobile-prodects-search' placeholder="请输入关键词" size="large" value={this.state.searchkey} onChange={this.changeinput}  onSearch={this.search} loading={this.state.loading} allowClear /></Row>
                    {!this.state.requestdone &&<Row style={{width:"80%",color:"white",margin:"auto"}}>紧随官方文件指导，了解政策最新动态~</Row>}
                    <div className={!this.state.requestdone?"mobile-prodects-result-body prodects-result-body-hide":"mobile-prodects-result-body"}>
                        {this.state.requestdone && JSXResultContent}
                        {
                            !this.state.loading &&
                            <Row className='mobile-model-result-pagination' justify='center'>
                                <Pagination defaultCurrent={1} current={this.state.pagination.cutpage} total={this.state.pagination.totalpage*10} showSizeChanger={false} onChange={this.changepage}/>
                            </Row>
                        }
                    </div>
                </div>
            )
        }   
    }

}

export default Policy;